import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { DashboardScreen } from '../screens';
import { getMenuAction } from './shared/sidebar.menu';
import { MainStack, MainTabNavigator } from './main.stack';
import { HeaderLogo } from './shared/header.logo';


const Stack = createStackNavigator();

export const DashboardStack = () => (
    <Stack.Navigator>
        <Stack.Screen
            name='Dash'
            component={DashboardScreen}
            options={{
                headerTitle: () => <HeaderLogo />,
                ...getMenuAction(true)
            }}
        />
    </Stack.Navigator>
);